import { Chip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useAuthContext } from '../../../../../hooks/useAuthContext'
import { userAssignmentService } from '../../../../../services/userAssignmentService'
import { getAssignedDataIdsValues } from '../utils/utils'

const UserAssignmentChips = ({
  userAssignmentData = [],
  assignee_id,
  assignmentFieldData = [],
  setUserAssignmentData,
  unassignedData = [],
  setUnassignedData,
  listDataCombinations,
}) => {
  const { user } = useAuthContext()
  const [assignedData, setAssignedData] = useState([])

  useEffect(() => {
    // Fetch Assignee's Assignment Combinations
    const assigneeData = userAssignmentData.find((user) => user.user_id === assignee_id)

    if (assigneeData) {
      const data = assigneeData?.assignments?.data_ids || []

      setAssignedData(data)
    } else {
      setAssignedData([]) // Ensure assignedData resets when no assigneeData is found
    }
  }, [assignee_id, userAssignmentData])

  const handleDelete = async (index, isAssigned, unassignedData) => {
    const updatedDataIds = (isAssigned ? assignedData : unassignedData).filter(
      (_, i) => i !== index
    )

    const result = listDataCombinations.map((combination) => {
      return combination.map((item) => item.list_data_id)
    })

    let unassigned = []
    result.forEach((comb) => {
      const isAssigned = updatedDataIds.some(
        (assignedComb) => JSON.stringify(assignedComb) === JSON.stringify(comb)
      )
      if (!isAssigned) {
        unassigned.push(comb)
      }
    })

    if (isAssigned) {
      const userDatum = userAssignmentData.find((user) => user.user_id === assignee_id)
      if (userDatum) {
        const updatedUserAssignmentData = userAssignmentData.map((user) => {
          if (user.user_id === assignee_id) {
            return {
              ...user,
              assignments: {
                ...user.assignments,
                data_ids: updatedDataIds,
              },
            }
          }
          return user
        })
        setUserAssignmentData(updatedUserAssignmentData)
        setUnassignedData(unassigned)
        await userAssignmentService.updateUserActivityAssignments(user, {
          assignee_id: assignee_id,
          activity_template_id: userDatum.assignment_for_activity_id,
          data_ids: updatedDataIds,
        })
      }
    }
  }

  return (
    <>
      {assignedData.length > 0 && (
        <div style={{ paddingBlock: 5, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {assignedData.map((datum, index) => (
            <Chip
              key={`chip_assigned_${index}`}
              label={getAssignedDataIdsValues(datum, assignmentFieldData)}
              onDelete={() => handleDelete(index, true, unassignedData)}
              variant="outlined"
            />
          ))}
        </div>
      )}

      {unassignedData.length > 0 ? (
        <div style={{ paddingBlock: 5, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {unassignedData.map((datum, index) => (
            <Chip
              key={`chip_unassigned_${index}`}
              label={getAssignedDataIdsValues(datum, assignmentFieldData)}
              variant="outlined"
            />
          ))}
        </div>
      ) : (
        assignedData.length === 0 && (
          <Typography
            variant="caption"
            color="lightgrey"
            fontFamily="sans-serif"
            fontStyle="italic"
          >
            No Unassigned Data
          </Typography>
        )
      )}
    </>
  )
}

export default UserAssignmentChips
